<template>
    <div ref="chart" class="small-line-chart"></div>
</template>

<script>
    export default {
        name: "smallLineChart",
        props: {
            scoreList: {
                type: Array,
                default: () => []
            }
        },
        mounted() {
            this.drawLineChart()
        },
        methods: {
            drawLineChart() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        const categoryList = this.scoreList.map(s => s['date'])
                        const dataList = this.scoreList.map(s => s['value'])
                        const option = {
                            grid: {
                                top: '10%',
                                bottom: '10%',
                                left: '3%',
                                right: '3%'
                            },
                            tooltip: {
                                show: true,
                                confine: true,
                                appendToBody: false,
                                textStyle: {
                                    fontSize: 12
                                },
                                formatter: '{b0}：{c0}'
                            },
                            xAxis: {
                                type: 'category',
                                splitLine: {
                                    show: false
                                },
                                axisLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    show: false
                                },
                                data: categoryList
                            },
                            yAxis: {
                                type: 'value',
                                splitLine: {
                                    show: false
                                },
                                axisLine: {
                                    show: false
                                },
                                axisTick: {
                                    show: false
                                },
                                axisLabel: {
                                    show: false
                                },
                            },
                            series: {
                                type: 'line',
                                itemStyle: {
                                    normal: {
                                        color: '#5AD8A6'
                                    }
                                },
                                areaStyle: {
                                    color: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [
                                            {offset: 0, color: '#5AD8A6'},
                                            {offset: 1, color: 'rgba(90,216,166,0.16)'}
                                        ]
                                    }
                                },
                                data: dataList
                            }
                        }

                        if (this.$refs.chart) {
                            const chart = this.$echarts.init(this.$refs.chart)
                            chart.setOption(option)
                        }
                    }, 500)
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.small-line-chart {
    min-width: 75px;
    height: 40px;
}
</style>
